import { useOptimizedRecord } from '@/shared/hooks/useOptimizedQuery'

import type { MyData } from '../types'

/**
 * Inventário simplificado dos dados do aluno (LGPD): dados pessoais, jornadas
 * concluídas/progresso e missões. Mesma fonte usada pela exportação.
 */
export function useMyData() {
  return useOptimizedRecord<MyData>({
    path: '/user/my_data'
  })
}
